import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import Loader from "../../components/common/Loader";
// import ErrorSpan from "./ErrorSpan";

const AddNewClient = () => {
  const token = sessionStorage.getItem("token"); // JWT token stored previously
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const websiteRegex = /^(https?:\/\/)?((localhost(:\d+)?|(127\.\d+\.\d+\.\d+)|([a-zA-Z0-9-]+\.[a-zA-Z]{2,})))(:\d+)?(\/\S*)?$/;
  const validatePhoneNumber = (number) => /^\d{8,14}$/.test(number);
  const [generalMaster, setGeneralMaster] = useState([]);



  const [formData, setFormData] = useState({
    clientName: "",
    contactPerson: "",
    email: "",
    phoneNumber: "",
    industry: "",
    address: "",
    gstin: "",
    pan: "",
    status: false,
    website: "",
    location: "",
    notes: ""
  });

  const [errors, setErrors] = useState({});
  const { id } = useParams();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      const fetchEmployee = async () => {
        const res = await fetch(`${API_BASE_URL}/api/Clients/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.ok) {
          const data = await res.json();

          setFormData(data);
        }
      };
      fetchEmployee();
      setLoading(false);
    }
  }, [id, token]);

  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();

  }, [token]);

  const validateForm = () => {
    for (let key of Object.keys(formData)) {
      if (!["notes", "website", "location", "status"].includes(key)) {
        const value = formData[key];

        if (
          value === null ||
          value === undefined ||
          (typeof value === "string" && value.trim() === "")
        ) {
          setNotification({
            type: "error",
            message: `${key.charAt(0).toUpperCase() + key.slice(1)} is required`,
          });
          window.scrollTo({ top: 0, behavior: "smooth" });
          return false;
        }
      }
    }

    if (!validatePhoneNumber(formData.phoneNumber)) {
      setNotification({
        type: "error",
        message: "Please enter a valid Phone Number.",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      setNotification({ type: "error", message: "Invalid email address" });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    }

    if (!formData.pan || !panRegex.test(formData.pan)) {
      setNotification({
        type: "error",
        message: "Please enter a valid PAN (e.g., ABCDE1234F)",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    }

    if (formData.website && !websiteRegex.test(formData.website)) {
      setNotification({
        type: "error",
        message: "Please enter a valid website URL (e.g., https://example.com)",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    }

    return true;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      setLoading(true);
      const method = id ? "PUT" : "POST";
      const url = id
        ? `${API_BASE_URL}/api/Clients/${id}`
        : `${API_BASE_URL}/api/Clients`;

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("API Error:", response.status, errorText);
      } else {
        closeSubmit();
      }
    } catch (error) {
      console.error(error);
      alert("Error saving client");
    } finally {
      setLoading(false);
    }
  };

  const closeSubmit = () => {
    navigate("/app/clientslist");
  };
  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <>
      {loading ? (
        <Loader message="Loading..." />
      ) : (
        <div className="flex flex-1 justify-center py-5">
          <form
            onSubmit={handleSubmit}
            className="layout-content-container grid grid-cols-2 gap-6 w-full py-5"
          >
            <div className="col-span-2 flex justify-between">
              <p className="text-[#121416] tracking-light text-[32px] font-bold leading-tight">
                Add New Client
              </p>
            </div>

            {notification && (
              <div className={`col-span-2 mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                }`}>
                <span>{notification.message}</span>
                <button onClick={handleCloseNotification} className="ml-4 font-bold text-lg leading-none">×</button>
              </div>
            )}

            {/* Client Name */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Client Name<span className="text-red-500">*</span></p>
              <input
                name="clientName"
                value={formData.clientName}
                onChange={handleChange}
                placeholder="Enter client name"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Contact Person */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Contact Person<span className="text-red-500">*</span></p>
              <input
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                placeholder="Enter contact person's name"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Email */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Email<span className="text-red-500">*</span></p>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter email address"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Phone Number */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Phone Number<span className="text-red-500">*</span></p>
              <input
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Enter phone number"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Industry */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Industry<span className="text-red-500">*</span></p>
              <select
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              >
                <option value="">Select</option>
                {generalMaster.filter((x) => x.mainId == 92)
                  .map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.title}
                    </option>
                  ))}
              </select>
            </label>

            {/* GSTIN */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">GSTIN<span className="text-red-500">*</span></p>
              <input
                name="gstin"
                value={formData.gstin}
                onChange={handleChange}
                placeholder="Enter GSTIN"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* PAN */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">PAN<span className="text-red-500">*</span></p>
              <input
                name="pan"
                value={formData.pan}
                onChange={handleChange}
                placeholder="Enter PAN"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Website */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Website</p>
              <input
                name="website"
                value={formData.website}
                onChange={handleChange}
                placeholder="Enter website URL"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Location */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Location</p>
              <input
                name="location"
                value={formData.location}
                onChange={handleChange}
                placeholder="Enter client location"
                className="form-input w-full rounded-xl bg-[#f1f2f4] h-14 p-4 text-base"
              />
            </label>

            {/* Status */}
            <label className="flex items-end gap-2 pb-2">
              <input
                type="checkbox"
                name="status"
                checked={formData.status}
                onChange={handleChange}
                className="h-5 w-5"
              />
              <span className="text-base font-medium text-[#121416]">Active</span>
            </label>

            {/* Address */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Address<span className="text-red-500">*</span></p>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter client address"
                className="form-input w-full rounded-xl bg-[#f1f2f4] min-h-36 p-4 text-base"
              ></textarea>
            </label>

            {/* Notes */}
            <label className="flex flex-col">
              <p className="pb-2 text-base font-medium text-[#121416]">Notes</p>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                placeholder="Additional notes about the client"
                className="form-input w-full rounded-xl bg-[#f1f2f4] min-h-36 p-4 text-base"
              ></textarea>
            </label>

            {/* Buttons */}
            <div className="col-span-2 flex justify-end gap-3 px-4 py-3">
              <button
                type="button"
                onClick={() => closeSubmit()}
                className="cancel-btn"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-black"
              >
                {id ? "Update Client" : "Save Client"}
              </button>
            </div>
          </form>

        </div>
      )}
    </>
  );
};

export default AddNewClient;